import { Box, Divider } from "@mui/material";
import { useContext } from "react";

import { ChatContext } from "../../contexts/chat/context";
import { ChatStatus } from "./chat_status";
import { InputContainer } from "./input_container";
import { MessageContainer } from "./message_container";

export const Chat = () => {
  const { isConnected } = useContext(ChatContext);
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <ChatStatus isConnected={isConnected} />
      <Divider />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <MessageContainer />
        </Box>
        <Box
          sx={{
            p: 1,
            display: "flex",
            width: "100%",
            height: "150px",
            gap: 1,
          }}
        >
          <InputContainer />
        </Box>
      </Box>
    </Box>
  );
};
